<template>
    <plain-layout :isPlain="true" :showTerms="false">
        <div>
            <common-page-header class="connections__header" :heading="pageTitle"></common-page-header>
            <common-content-spacer height="small">
                <common-tabs :tabs="tabs" :activeTab="tabs[0].name" @tab-click="tabChange($event)">
                    <template v-slot:physicians>
                        <provider-table-filter @filter-changed="filterChanged"></provider-table-filter>
                        <provider-table :filters="filters" :practiceType="practiceType"></provider-table>
                    </template>
                    <template v-slot:providers>
                        <provider-table-filter @filter-changed="filterChanged"></provider-table-filter>
                        <provider-table :filters="filters" :practiceType="practiceType"></provider-table>
                    </template>
                </common-tabs>
            </common-content-spacer>
        </div>
    </plain-layout>
</template>

<script>
    import PlainLayout from 'components/layouts/PlainLayout'
    import ProviderTable from 'components/page-elements/ehr/ProviderTable'
    import ProviderTableFilter from 'components/page-elements/ehr/ProviderTableFilter'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        mixins: [],

        components: {
            PlainLayout,
            ProviderTable,
            ProviderTableFilter,
        },

        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
                practiceType: PracticeTypeEnum.PHYSICIAN,
                filters: null,
            }
        },

        computed: {
            tabs() {
                const tabs = [
                    {
                        name: 'physicians',
                        displayName: this.$t('pages.network.connections.tabs.physicians'),
                        icon: 'member-transparent',
                    },
                    {
                        name: 'providers',
                        displayName: this.$t('pages.network.connections.tabs.providers'),
                        icon: 'colleague-transparent',
                    },
                ]

                return tabs
            },

            pageTitle() {
                return this.$t('pages.network.ehr.header')
            },
        },

        methods: {
            tabChange(tabName) {
                if (tabName === this.tabs[0].name) {
                    this.physiciansTabClicked()
                } else {
                    this.ancillaryTabClicked()
                }
            },

            physiciansTabClicked() {
                this.practiceType = PracticeTypeEnum.PHYSICIAN
            },

            ancillaryTabClicked() {
                this.practiceType = PracticeTypeEnum.ANCILLARY
            },

            filterChanged(payload) {
                this.filters = payload
            },
        },

        mounted() {},
    }
</script>

<style lang="scss">
    .ehr {
    }
</style>
